import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { withRouter, Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import Logo from './Logo'
import Button from '../Common/button'
import StyleGuide from '../Global/StyleGuide'
import { logOut } from '../services/auth'
import useWindowSize from '../Hooks/useWindowSize'
import { buildTestID } from '../Utils/utils'
import EmptyStateLogoIcon from '../assets/empty-state-logo-icon'
import {
  trackUserSignedOut,
} from '../Global/Analytics'
import { useLoggedInUser } from '../Hooks/useLoggedInUser'
import HomeToolkitIcon from '../assets/home-toolkit-icon';
import { useRetrievePayOffEligibility } from '../Hooks/useRetrievePayOffEligibility'
import { useRetrieveLocEligibility } from '../Hooks/useRetrieveLocEligibility'

const StyledHeaderFinishYourAccount = styled.div`
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);
  position: fixed;
  width: 100%;
  background: white;
  top: 0;
  z-index: 200;

  .top_nav,
  .bottom_nav {
    min-height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 56px;

    .logo_placeholder {
      margin: 0;
      line-height: inherit;
      text-decoration: none;
      color: ${({ theme }) => theme.colors.black};

      .screen_reader_only {
        display: none;
      }
    }

    .row {
      display:flex;
      flex-direction:row;
      flex-wrap:nowrap;
      
      div {
        white-space: nowrap;
      }
    }
    .links_top_nav {
      margin-right: 10px;
    }

    .links_top_nav,
    .links_bottom_nav {
      white-space: nowrap;
      display: flex;
      align-items: center;

      .body-2 {
        text-decoration: none;
        color: ${({ theme }) => theme.colors.black};

        :hover {
          color: ${({ theme }) => theme.colors.primary};
        }
      }

      a {
        margin-left: 24px;
      }
    }
  }

  .break_line {
    margin: 0;
  }

  .bottom_nav {
    min-height: unset;
    .links_bottom_nav {
      a {
        margin: 0;
        padding: 0 16px;
        height: 56px;
        display: flex;
        align-items: center;
        border-bottom: 4px solid ${({ theme }) => theme.colors.white};
      }
      .selected {
        border-bottom: 4px solid
          ${({ theme }) => theme.colors.primary};
      }
    }
  }

  .top_nav {
    min-height: unset;
    height: 80px;

    .links_top_nav {
      margin-left: 8px;
      a.body-2 {
        margin: 0;
        padding: 0 12px;
        height: 56px;
        display: flex;
        align-items: center;
        border-bottom: 4px solid ${({ theme }) => theme.colors.white};
      }

      a.body-2.selected {
        border-bottom: 4px solid
          ${({ theme }) => theme.colors.primary};
      }
    }
  }

  .dropdown {
    position: relative;

    button {
      margin: 0 0 0 16px;
      font-size: 18px;
      line-height: 24px;
      padding: 0 30px 4px 0;
      border-radius: 4px;
      border: none;
      color: ${({ theme }) => theme.colors.black};
      background: ${({ theme }) => theme.colors.white};

      ::after {
        display: none;
      }

      :active,
      :focus,
      :focus-visible,
      :focus-within,
      :target,
      :visited {
        border: none !important;
        color: black !important;
        background-color: white !important;
        box-shadow: none !important;
        background-color: white !important;
        border-color: white !important;
      }

      :hover {
        color: ${({ theme }) => theme.colors.primary} !important;
      }
    }

    .chev_icon {
      pointer-events: none;
      position: absolute;
      right: 14px;
      top: 22px;
      transform: ${({ onlineToolsOpen }) =>
    onlineToolsOpen ? 'rotate(90deg)' : 'rotate(270deg)'};
    }

    .dropdown-menu {
      border-radius: 4px;
      padding: 0;
      transform: translate3d(0px, 42px, 0px) !important;

      min-width: unset;
      width: unset;

      .dropdown-item {
        border: 0;
        color: ${({ theme }) => theme.colors.black};
        text-decoration: none;
        font-weight: normal;
        padding: 12px 16px;

        :active {
          background: none;
        }

        :hover {
          background: ${({ theme }) => theme.colors.lightGrey};
        }
      }
    }
  }

  .mobile_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 8px 24px;

    .burger {
      background: ${({ theme }) => theme.colors.white};
      align-self: end;
      display: flex;
      width: 40px;
      height: 40px;
      border: 1px solid ${({ theme }) => theme.colors.black12};
      border-radius: 4px;
      padding: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      .line {
        border: 0.5px solid ${({ theme }) => theme.colors.black60};
        width: 18px;
        border-radius: 4px;
      }
      :hover {
        outline: ${({ theme }) => theme.colors.primary} auto 1px;
      }
      :focus {
        outline: ${({ theme }) => theme.colors.primary} auto 1px;
      }
    }
  }

  .mobile_nav {
    position: absolute;
    min-width: 100vw;
    transition: all 0.2s ease-in;
    overflow-y: auto;
    height: calc(100vh - 60px);

    display: flex;
    flex-direction: column;
    background: ${({ theme }) => theme.colors.white};
    padding: 0;
    box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.2);

    .mobile_link {
      text-align: start;
      text-decoration: none;
      color: ${({ theme }) => theme.colors.black};
      padding: 12px 24px;
      margin: 0 8px;
    }

    .mobile_link.selected {
      color: ${({ theme }) => theme.colors.primaryDark};
      background: ${({ theme }) => theme.colors.primary4};
      border-radius: 4px;
    }

    .buttons {
      padding: 0 24px 34px 24px;
      .button {
        margin: 20px 0 0 0;
        text-align: center;
        width: 360px;
      }
    }
  }

  #online-tools-menu {
    padding: 16px 0;
    margin-right: 2px;

    &:focus-within {
      outline: 2px solid #1460AA;
    }
  }

  @media (max-width: ${({ theme }) => theme.breakPoints.medium}) {

  }

  @media (max-width: ${({ theme }) => theme.breakPoints.xSmall}) {
    .mobile_nav {
      .buttons {
        .button {
          width: 100%;
        }
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakPoints.medium}) {
    .top_nav {
    height: 80px;
    flex-shrink: 0;
    background: var(--Surface, #FFF);
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.15);

    a.body-2 {
      color: #000;
      font-family: Lato;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }    
 }

  @media screen and ( min-width: 864px ) and ( max-width: 1008px){
    .links_top_nav {
      a {
        font-size: .75rem;
      }
    }
  }
`

const UnAuthedLinks = [ 
  {text: 'My Home Toolkit', link:'home-toolkit'},
  { text: 'Make a Payment', link: 'payment' },
  { text: 'Helpful Resources', link: 'helpful-resources' },
  { text: 'Common Questions', link: 'common-questions' },
  { text: 'Common Forms', link: 'common-forms' },
  { text: 'Contact Us', link: 'contact' },
]

const buildTestIDHeader = (text) => {
  return buildTestID(text, '/home', 'header')
}

const HeaderFinishYourAccount =({
  history,
  isAuthenticated,
  navVisible,
  setNavVisible,
}) => {
  const [selectedNavItem, setSelectedNavItem] = useState('')
  const { data, loading } = useLoggedInUser(isAuthenticated)
  const userIsLoggedIn = !loading && data
  const { isSmall, isXSmall } = useWindowSize()
  const { pathname } = useLocation()

  const { 
    data: eligibilityData,
  } = useRetrieveLocEligibility()
  const {
    data: payoffData,
  } = useRetrievePayOffEligibility();

  useEffect(() => {
    setSelectedNavItem(pathname.slice(1))
  }, [pathname])

  // updates online tools dropdown nav to reflect available online tools
  useEffect(() => {
    if (!userIsLoggedIn) return
  }, [userIsLoggedIn])

  const mobileLinks = userIsLoggedIn
    ? [
      ...UnAuthedLinks,
    ]
    : UnAuthedLinks

  const onLandingPage = selectedNavItem === ''

  return (
    <StyleGuide>
      <StyledHeaderFinishYourAccount
        role="navigation"
        mobileNavHeight={
          isXSmall ? '100vh' : mobileLinks.length * 48 + 150 + 'px'
        }
        navVisible={navVisible}
      >
        {!isSmall ? (
          <>
            <div className="top_nav">
              {userIsLoggedIn ? (
                <Logo />
              ) : (
                <a
                  href="/"
                  className="body-2 logo_placeholder"
                  data-testid={buildTestIDHeader('Reverse Mortgage')}
                  aria-label=" Reverse Mortgage Servicing Department home link"
                >
                  <span className="screen_reader_only">
                    Reverse Mortgage Servicing Department
                  </span>
                  <EmptyStateLogoIcon />
                </a>
              )}
              <div className="links_top_nav">
                {UnAuthedLinks.map((link) => {
                  return (
                    <>
                    {link.link === 'home-toolkit' ? <HomeToolkitIcon/> : null}
                    <Link
                      data-testid={buildTestIDHeader(link.text)}
                      key={link.link}
                      to={link.link}
                      className={`body-2 ${selectedNavItem === link.link
                        ? 'selected'
                        : ''
                        }`}
                    >
                      {link.text}
                    </Link>
                    </>
                  )
                })}
              </div>
              <div className='row'>
              {!userIsLoggedIn && selectedNavItem !== 'register' ? (
                  <Button
                    className="create_account_button_full_screen"
                    linkTo="/register"
                    text="Create Account"
                    outlined
                    small
                    refreshPage
                    UID="create_account_nav"
                  />
                ) : null}
                {userIsLoggedIn ? (
                  <Button
                    text="Log Out"
                    UID="log_out_nav"
                    onClick={(e) => {
                      trackUserSignedOut()
                      e.preventDefault()
                      sessionStorage.clear()
                      logOut()
                      history.push('/')
                      setNavVisible(false)
                    }}
                    small
                    linkTo="/"
                  />
                ) : !onLandingPage ? (
                  <Button
                    UID="sign_in_nav"
                    text="Sign In"
                    small
                    linkTo="/"
                    refreshPage
                  />
                ) : null}
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="mobile_header">
              {userIsLoggedIn ? (
                <Logo />
              ) : (
                <a
                  href="/"
                  className="body-2 logo_placeholder"
                  data-testid={buildTestIDHeader('Reverse Mortgage')}
                  aria-label=" Reverse Mortgage Servicing Department home link"
                >
                  <EmptyStateLogoIcon />
                </a>
              )}
              <button
                data-testid={buildTestIDHeader('Hamburger')}
                className="burger"
                onClick={() => setNavVisible(!navVisible)}
                aria-expanded={navVisible}
                aria-label={navVisible ? 'menu button expanded' : 'menu button collapsed'}
                aria-controls="mobile-menu"
              >
                <div className="line" />
                <div className="line" />
                <div className="line" />
              </button>
            </div>
            <div id="mobile-menu" className="mobile_nav" aria-hidden={!navVisible} style={{ "display": navVisible ? 'flex' : 'none' }}>
              {mobileLinks.map((link) => {
                return link.text !== 'Voluntary Prepayments/Repayment Plan Payments' ? (
                <Link
                  data-testid={buildTestIDHeader(
                    link.text + '_mobile',
                  )}
                  key={link.link}
                  to={link.link}
                  className={`body-1 mobile_link ${selectedNavItem === link.link ? 'selected' : ''
                    }`}
                >
                   {link.link === 'home-toolkit' ? <HomeToolkitIcon /> :null}
                  {link.text}
                </Link>
                ) : (<Link
                  data-testid={buildTestIDHeader(
                    'repayment_mobile',
                  )}
                  key={'repayment_mobile'}
                  to={{ pathname: link.link }}
                  className={`body-1 mobile_link ${selectedNavItem === 'repayment_mobile' ? 'selected' : ''
                    }`}
                >
                  {link.text}
                </Link>)
              })}
              <div className="buttons">
                {userIsLoggedIn ? (
                  <Button
                    className="button"
                    text="Log Out"
                    UID="log_out_nav_mobile"
                    onClick={(e) => {
                      trackUserSignedOut()
                      e.preventDefault()
                      sessionStorage.clear()
                      logOut()
                      history.push('/')
                      setNavVisible(false)
                    }}
                    small
                    linkTo="/"
                    fullWidth
                  />
                ) : !onLandingPage ? (
                  <Button
                    className="button"
                    UID="sign_in_nav_mobile"
                    text="Sign In"
                    small
                    linkTo="/"
                    refreshPage
                    fullWidth
                  />
                ) : null}
                {!userIsLoggedIn ? (
                  <Button
                    className="button"
                    linkTo="/register"
                    text="Create Account"
                    outlined
                    small
                    refreshPage
                    UID="create_account_nav_mobile"
                    fullWidth
                  />
                ) : null}
              </div>
            </div>
          </>
        )}
      </StyledHeaderFinishYourAccount>
    </StyleGuide>
  )
}

HeaderFinishYourAccount.propTypes = {
  history: PropTypes.object.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  navVisible: PropTypes.bool.isRequired,
  setNavVisible: PropTypes.func.isRequired,
}

export default withRouter(HeaderFinishYourAccount)
